import { createContext, useContext } from 'react';
import { AuthContextType } from './types';

// Default context values
const defaultAuthContext: AuthContextType = {
  isAuthenticated: false,
  user: null,
  login: async () => false,
  register: async () => {},
  logout: async () => {},
  notifications: [],
  unreadNotificationsCount: 0,
  markNotificationAsRead: () => {},
  deleteNotification: () => {},
  switchRole: () => {},
  impersonateUser: async () => {},
  isLoadingAuth: false,
  isLoggingOut: false,
};

// Create the context with default values
export const AuthContext = createContext<AuthContextType>(defaultAuthContext);

export const useAuth = () => useContext(AuthContext);
